import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '@banyan/commons/components/button/button.component';
import { ModalComponent } from '@banyan/commons/components/modal/modal.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-server-modal',
  templateUrl: './error-server-modal.component.html',
  styleUrls: ['./error-server-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ModalComponent,
    TranslateModule,
    RouterModule,
    ButtonComponent,
  ],
})
export class ErrorServerModalComponent {
  private readonly dialogRef = inject<MatDialogRef<ErrorServerModalComponent>>(MatDialogRef);


  closeModal(): void {
    this.dialogRef.close();
  }
}
